import {React, useState} from 'react'
import {Modal,ModalBody,ModalHeader,ModalFooter, Button,Card,CardImg,CardTitle} from 'reactstrap';
import {FaPhoneAlt} from "react-icons/fa"
import Zoom from 'react-reveal/Zoom';
import GlitchClip from 'react-glitch-effect/core/GlitchClip';
import useSound from 'use-sound';
import sfx1 from '../assets/close.mp3';
import sfx from '../assets/click.mp3';

const Event = ({event,rules,text,img,name,no,name1,no1,cost,link})=> {
  const [modal, setModal] = useState(false);
  const [play] = useSound(sfx)
  const [play1] = useSound(sfx1);

  const toggle = () => setModal(!modal);
    return (
      <Zoom>
        <Card body className="text-white" onClick={()=>{toggle();play()}} >
          <CardTitle tag="h5" className="text-center">{event}</CardTitle>
          {(img)?(<CardImg src={img.default} alt="Card image cap" />):(null)}
          
            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle} onClick={play1} tag="h2"><GlitchClip>{event}</GlitchClip></ModalHeader>
                <ModalBody> 
                            {(text)?(text.split('\n').map(str => <p className="my-1">{str}</p>)):(null)}
                            <br></br>
                            <h5>RULES_</h5>
                            {(rules)?(rules.split('\n').map(str => <p className="my-1">{str}</p>)):(null)}
                            <br></br>
                            {(cost)?(<div><h5 className="cost">ENTRY FEE_{cost}</h5><br></br></div>):(<div><h5 className="cost">ENTRY_FREE</h5><br></br></div>)}
                            {(name&&no)?(<h5>CONTACT_</h5>):(null)}
                            {(name1&&no1)?(<div className="callbox">
                              <a className="btn btn-success call" href={`tel:${no1}`}><FaPhoneAlt className="mr-1"></FaPhoneAlt>{name1}</a>
                              <h6>{`[+91 ${no1}]`}</h6>
                            </div>):(null)}
                            {(name&&no)?(<div className="callbox">
                              <a className="btn btn-success call" href={`tel:${no}`}><FaPhoneAlt className="mr-1"></FaPhoneAlt>{name}</a>
                              <h6>{`[+91 ${no}]`}</h6>
                            </div>):(null)}        
                </ModalBody>
              <ModalFooter>
                {(link)?(<a className="reg-btn"  onClick={()=>{toggle();play1()}} href={link}>Register</a>):(<div className="cls-btn" onClick={(e)=>(e.preventDefault)}>Registrations Closed</div>)}
                <Button className="ok" onClick={()=>{toggle();play1()}}>OK</Button>
              </ModalFooter>
            </Modal>
        </Card>
        </Zoom>
    )
}

export default Event;
